import { splitSearchKeyword } from "./split-search-keyword.function";


export function searchEntitiesByKeyword<T extends Object>(
  searchKeyword: string,
  entities: T[],
  entitySearchFields: string[][],
  sortByDate = true
): T[] {
  entities = [...entities];
  if (!entities.length) {
    return [];
  }
  if (!searchKeyword.length) {
    if (entities[0]?.hasOwnProperty('updatedOn') && sortByDate) {
      entities.sort((a, b) => {
        var dateA = new Date((a as unknown as any)?.updatedOn || '').getTime();
        var dateB = new Date((b as unknown as any)?.updatedOn || '').getTime();
        return dateA < dateB ? 1 : -1; // ? -1 : 1 for ascending/increasing order
      });
    }
    return entities;
  }
  const words = splitSearchKeyword(searchKeyword);
  const keywords: string[] = words.reduce((list: string[], keyword: string) => {
    const parts: string[] = splitSearchKeyword(keyword, '-');
    if (parts.length > 1) {
      list = list.concat(parts);
    } else {
      list.push(keyword);
    }

    // list.push(keyword.toLowerCase());
    return list;
  }, []);

  return entities.reduce((filtered: T[], entity: T, i) => {
    const searchFieldsString = entitySearchFields[i].join('').toLowerCase();
    const searchIndexes = keywords.map((keyword) =>
      searchFieldsString.indexOf(keyword)
    );
    const matchesAll = searchIndexes.every((index) => index >= 0);
    if (matchesAll) {
      filtered.push(entity);
    }
    return filtered;
  }, []);
}